export enum Clients {
  Clubdiabetes = 'clubdiabetes',
}